<template>

    <v-card :if="image" style="-ms-interpolation-mode: nearest-neighbor!important;
                image-rendering: -webkit-optimize-contrast!important; 
                image-rendering: -webkit-crisp-edges!important; 
                image-rendering: -moz-crisp-edges!important; 
                image-rendering: -o-crisp-edges!important; 
                image-rendering: pixelated!important;cursor: pointer">
      <span style="position:absolute;z-index:2;font-size:30px;top:5%;left:5%">&nbsp;{{image.name}}</span>
      <!-- <img :src="image.icon" height="400px" > -->
      <v-img  :src="image.icon" height="300px"></v-img>
      <!-- <v-img :src="image.icon" width=""></v-img> -->
      <v-card-actions class="px-4">
        <v-layout align-center justify-center row fill-height py-3>
          <v-flex xs10>
          
            <p class="caption text--secondary" style="font-size:13.5px!important; color:#081e3f !important">
               {{externalFvc.description}}
            </p>
          </v-flex>
        </v-layout>
        <!--  <v-spacer></v-spacer> -->
        <v-btn small color="accent" dark :href="image.url" target="_blank">{{$t('message.open')}}</v-btn>
      </v-card-actions>
    </v-card>
  </template>
  <script>
  import { mapGetters } from "vuex";
  import Vue from "vue";
  export default {
    mounted() {},
    computed: {
      ...mapGetters(["externalFvc", "loadingExternal","agency"])
    },
    props: {
      image: {
        type: Object,
        required: true
      }
    },
    data() {
      return {};
    },
  
    methods: {}
  };
  </script>
  <style scope>
  .absolute {
    position: absolute;
    top: 0;
    left: 0;
    padding-left: 50px;
    padding-top: 50px;
  }
  </style>
  